import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer";
import {PasswordContainer} from "../../../../components/PasswordContainer";
import React, {memo} from "react";
import './index.scss'
import {useLocalization} from "../../../../hooks/localization";
import {useSelector} from "react-redux";

export const LanguageListScreen = memo(function LanguageListScreen() {
    const languageList = useSelector(state => state.control.languageList);

    const {changeLanguage, t} = useLocalization();

    return (
        <PasswordContainer requiredRole="user" isFullscreen={true}>
            <SettingsPageContainer
                className="language-screen"
                buttons={[]}
                title={t('language')}
                backUrl={'/settings'}>
                <div className="content-divider">
                    <div className="content-wrapper">
                        {
                            languageList.map(language => (
                                <button className="language-btn" onClick={() => changeLanguage(language.id)}>
                                    <span>{language.name}</span>
                                </button>
                            ))
                        }
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    );
})
